import React from 'react'
import { Link } from 'react-router-dom';


export const ChannelCard = (props) => {
    const {video} = props;
    const demoThumbnailUrl = 'https://i.ytimg.com/vi/eO5du5L02TQ/hqdefault.jpg?sqp=-oaymwEXCOADEI4CSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLAXOFXmkcR53sIrRQGq-RZ4duvIpg';

  return (
    <div className="video__card flex flex-col   wrap space-y-2 w-[250px]  md:w-[300px] " >  
        <div className="video__card__thumbnail">
    <img src={video?.snippet?.thumbnails?.medium?.url || demoThumbnailUrl} className='w-[250px]  md:w-[280px] rounded-full'  alt={video.snippet.title} />
</div>
<div className="video__card__details space-y-3">
    <div className='flex space-x-1 items-center justify-center'>
        <Link to={`/channel/${video.snippet.channelId}`}>
    <h3 className='text-white font-bold text-xl text-center'>{video?.snippet?.channelTitle || video.snippet.title} 
    </h3>
        </Link>
    <span>
    <svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false" className="w-4 " style={{fill:"#aaa"}}><g className="style-scope yt-icon"><path d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M9.8,17.3l-4.2-4.1L7,11.8l2.8,2.7L17,7.4 l1.4,1.4L9.8,17.3z" className="style-scope yt-icon"></path></g></svg>
    </span>
    </div>
</div>
</div>
  )
}
